module.exports = __webpack_public_path__ + "p6_img4.jpg?600ed77e2ea942911ab6ac0ee4dc6261";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p6/p6_img4.jpg
// module id = 182
// module chunks = 0